<template>
  <div class="relatorios">
    <el-form label-position="top">
      <el-tabs type="border-card" v-model="tabAtivo">
        
        <!-- Tab Filtros -->
        <el-tab-pane label="FILTROS" name="filtros">
          <div>
            <el-row :gutter="10" class="u-mt-10">
              <el-col :xs="24" :sm="18" :md="18">
                <el-form-item label="Instituição" key="instituicao" v-if="[4, 5, 6, 7, 8, 10, 11].includes(Number($store.state.user.tipo))">
                  <el-select ref="instituicao_id" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <div class="style-form" v-if="[0, 1, 3, 9, 12].includes(Number($store.state.user.tipo))">
                  <label class="el-form-item__label">Instituição</label>
                  <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="6" :md="6">
                <el-form-item label="Período Letivo" key="periodo">
                  <el-select ref="periodo_letivo_id" v-model="filtro.periodo_letivo_id">
                    <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="item.nome" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="10" v-if="![0, 1, 3, 12].includes(Number($store.state.user.tipo))">
              <el-col :xs="24" :sm="8" :md="8">
                <el-form-item label="Localização / Zona" prop="localizacao_zona">
                  <el-select ref="localizacao_zona" v-model="filtro.localizacao_zona" clearable multiple placeholder="Urbana / Rural">
                    <el-option v-for="(item, i) in $CONSTANTS.LOCALIZACAO_ZONA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8">
                <el-form-item label="Localização Diferenciada" prop="localizacao_diferenciada">
                  <el-select ref="localizacao_diferenciada" v-model="filtro.localizacao_diferenciada" clearable multiple placeholder="Selecione...">
                    <el-option v-for="(item, i) in $CONSTANTS.LOCALIZACAO_DIFERENCIADA_ESCOLA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8">
                <el-form-item label="Situação de Funcionamento" prop="situacao_funcionamento">
                  <el-select ref="situacao_funcionamento" v-model="filtro.situacao_funcionamento" clearable multiple placeholder="Ativa / Inativa">
                    <el-option v-for="(item, i) in $CONSTANTS.SITUACAO_FUNCIONAMENTO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="10" v-if="![0, 1, 3, 12].includes(Number($store.state.user.tipo))">
              <el-col :xs="24" :sm="10" :md="10">
                <el-form-item label="Bairro" prop="bairro">
                  <el-select ref="bairro" v-model="filtro.bairro" placeholder="pesquisar..." filterable remote :remote-method="getBairroByFilter" :loading="loadingBairro" clearable>
                    <el-option v-for="item in selectBairros" :key="item.id" :label="item.nome" :value="item.nome"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="14" :md="14">
                <el-form-item label="Cursos Ofertados" prop="curso_id">
                  <el-select ref="curso" v-model="filtro.curso_id" filterable clearable multiple placeholder="Selecione...">
                    <el-option v-for="(item, i) in selectCursos" :key="i" :label="item.nome" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>

        <!-- Tab Campos -->
        <el-tab-pane label="CAMPOS" name="campos">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24">
              <label class="u-pl-5 u-mb-5" style="display: block; font-size: 15px;"><b>Campos de Instituição</b></label>
              <div style="height: 300px; background-color: #f8f8f8; padding:10px;">
                <el-checkbox-group v-model="campos.instituicao" class="checkbox-filtos">
                  <el-checkbox label="endereco">Endereço</el-checkbox>
                  <el-checkbox label="contatos">Contatos</el-checkbox>
                  <el-checkbox label="infraestruturas">Infraestrutura</el-checkbox>
                  <el-checkbox label="servicos">Serviços</el-checkbox>
                  <el-checkbox label="dependencias">Salas & Dependências</el-checkbox>
                  <el-checkbox label="equipamentos">Equipamentos</el-checkbox>
                  <el-checkbox label="profissionais">Profissionais</el-checkbox>
                  <el-checkbox label="turmas_alunos">Turmas & Alunos</el-checkbox>
                  <el-checkbox label="vagas">Vagas Ofertadas</el-checkbox>
                  <el-checkbox label="cursos_ofertados">Cursos Ofertados</el-checkbox>
                </el-checkbox-group>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-form>

    <div class="u-mt-10">
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
          <el-button @click="renderRelatorioGeralInstituicao('excel')" :loading="loadingButtonExcel" type="primary">EXCEL</el-button>
          <el-button @click="renderRelatorioGeralInstituicao('pdf')" :loading="loadingButtonPdf" type="primary">PDF</el-button>
          <el-button @click="renderRelatorioGeralInstituicao('html')" :loading="loadingButtonHtml" type="primary">HTML</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    tabAtivo: 'filtros',
    loadingButtonExcel: false,
    loadingButtonPdf: false,
    loadingButtonHtml: false,
    loadingBairro: false,
    selectBairros: [],
    selectCursos: [],
    campos: {
      instituicao: [
        'endereco',
        'contatos',
        'infraestruturas',
        'servicos',
        'dependencias',
        'equipamentos',
        'profissionais',
        'turmas_alunos',
        'vagas',
        'cursos_ofertados'
      ]
    },
    filtro: {
      instituicao_id: '',
      periodo_letivo_id: '',
      localizacao_zona: [],
      localizacao_diferenciada: [],
      bairro: '',
      curso_id: [],
      situacao_funcionamento: [1]
    },
    ref: []
  }),
  mounted() {
    this.filtro.periodo_letivo_id = this.$store.state.config.periodo.id;

    if ([0, 1, 3, 9, 12].includes(Number(this.$store.state.user.tipo))) {
      this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
    }

    this.getAllCursos();
  },
  methods: {
    getBairroByFilter(query) {
      if (query.length < 4) {
        this.selectBairros = [];
        return false;
      }

      this.loadingBairro = true;
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/bairro/searchByNome`, { query: query }, this.$store.getters.getHeaderAuth)
        .then(response => {
          this.selectBairros = JSON.parse(JSON.stringify(response.data));
          this.loadingBairro = false;
        })
        .catch(error => {
          this.loadingBairro = false;
          this.$store.commit('throwException', error);
        });
    },

    getAllCursos() {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/curso/getAllCurso`, this.$store.getters.getHeaderAuth)
        .then(response => {
          this.selectCursos = JSON.parse(JSON.stringify(response.data));
        })
        .catch(error => {
          this.$store.commit('throwException', error);
        });
    },

    addMultipleSelectFieldToRefFilter(name, valuesSelected) {
      const temp = { nome: name, valor: [] };
      if (Array.isArray(valuesSelected)) {
        valuesSelected.forEach(element => {
          temp.valor.push(element.currentLabel || element.label || '');
        });
      }
      this.ref.push(temp);
    },

    renderRelatorioGeralInstituicao(tipo) {
      if (this.campos.instituicao.length === 0) {
        window.eventBus.$emit('alert', {
          msg: 'É necessário selecionar pelo menos um campo a ser apresentado no relatório.',
          type: 'warning'
        });
        return false;
      }

      this.ref = [];

      let instLabel = 'TODAS';
      if ([0, 1, 3, 9, 12].includes(Number(this.$store.state.user.tipo))) {
        instLabel = this.$store.state.config.instituicao.nome;
      } else if (this.$refs.instituicao_id && this.$refs.instituicao_id.selected && this.$refs.instituicao_id.selected.label) {
        instLabel = this.$refs.instituicao_id.selected.label;
      }
      this.ref.push({ nome: 'Instituição', valor: instLabel });

      let periodoLabel = '';
      if (this.$refs.periodo_letivo_id && this.$refs.periodo_letivo_id.selected && this.$refs.periodo_letivo_id.selected.label) {
        periodoLabel = this.$refs.periodo_letivo_id.selected.label;
      } else {
        periodoLabel = 'Periodo Letivo ' + this.$store.state.config.periodo.nome;
      }
      this.ref.push({ nome: 'Período Letivo', valor: periodoLabel });

      if (this.filtro.bairro) {
        this.ref.push({ nome: 'Bairro', valor: this.filtro.bairro });
      }

      if (this.$refs.localizacao_zona && this.$refs.localizacao_zona.selected && this.$refs.localizacao_zona.selected.length > 0) {
        this.addMultipleSelectFieldToRefFilter('Localização / Zona', this.$refs.localizacao_zona.selected);
      }

      if (this.$refs.localizacao_diferenciada && this.$refs.localizacao_diferenciada.selected && this.$refs.localizacao_diferenciada.selected.length > 0) {
        this.addMultipleSelectFieldToRefFilter('Localização Diferenciada', this.$refs.localizacao_diferenciada.selected);
      }

      if (this.$refs.situacao_funcionamento && this.$refs.situacao_funcionamento.selected && this.$refs.situacao_funcionamento.selected.length > 0) {
        this.addMultipleSelectFieldToRefFilter('Situação de Funcionamento', this.$refs.situacao_funcionamento.selected);
      }

      if (this.$refs.curso && this.$refs.curso.selected && this.$refs.curso.selected.length > 0) {
        this.addMultipleSelectFieldToRefFilter('Cursos', this.$refs.curso.selected);
      }

      if (tipo === 'pdf') {
        this.loadingButtonPdf = true;
        this.renderPdf();
      } else if (tipo === 'html') {
        this.loadingButtonHtml = true;
        this.renderHtml();
      } else if (tipo === 'excel') {
        this.loadingButtonExcel = true;
        this.renderExcel();
      }
    },

    renderPdf() {
      window.eventBus.$emit('print', {
        url: '/api/pdf/renderRelatorioGeralInstituicao/pdf',
        param: { ref: this.ref, filtros: this.filtro, campos: this.campos }
      });
      this.loadingButtonPdf = false;
    },

    renderExcel() {
      this.$axios.post(
        `${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioGeralInstituicao/excel`,
        { param: { ref: this.ref, filtros: this.filtro, campos: this.campos } },
        this.$store.getters.getHeaderAuthExcel
      ).then(response => {
        this.loadingButtonExcel = false;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'relatorio_geral_instituicoes.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(error => {
        this.loadingButtonExcel = false;
        this.$store.commit('throwException', error);
      });
    },

    renderHtml() {
      this.loadingButtonHtml = true;

      // Open a blank tab synchronously to prevent the browser's popup blocker from blocking it
      const newTab = window.open('about:blank', '_blank');

      this.$axios.post(
        `${this.$store.state.config.baseUrlApi}/api/relatorio/generateCodAutorizacaoPrintHtml/geral-instituicao`,
        { ref: this.ref, filtros: this.filtro, campos: this.campos },
        this.$store.getters.getHeaderAuth
      ).then(response => {
        this.loadingButtonHtml = false;
        // Redirect the blank tab to the report URL
        newTab.location.href = `${process.env.VUE_APP_BASE_URL}/api/relatorio/open/${response.data.token}`;
      }).catch(error => {
        this.loadingButtonHtml = false;
        // Close the blank tab if the request failed
        newTab.close();
        window.eventBus.$emit('alert', { msg: 'Erro ao gerar relatório HTML.', type: 'warning' });
      });
    }
  }
}
</script>
